import memoize from 'lru-memoize';
import {linuxUserRules, createValidator, required, maxLength, email, userNoSpecialChars, noSpaces, minLength, isValidNumber} from 'utils/validation';

var userObj ={
		 
  nom: [required],
  prenom: [required],
  societe: [required],
  fonction: [required],
  login: [required, noSpaces, minLength(4), maxLength(30), userNoSpecialChars],
  password: [required, maxLength(12)],
  telephone: [isValidNumber]  
  /*email: [required, email],*/
		
}  

var mailObj = {address:[email, required]} 

const createUserValidation = createValidator([{user:userObj}, {mail:mailObj}]);


export default memoize(10)(createUserValidation);
